export interface PublishToPubSubResponse {
  success?: boolean;
  messageId?: string;
  topic?: string;
  timestamp?: string;
}

export async function publishToPubSub(
  event: string,
  authToken: string,
  hierarchicalMetadata: any,
  studyCondition : string | null = null,
  error: string = '',
  file: string = 'dicom',
  humanSubjectId: string | null = null,
  newStudyInstanceUID: string | null = null,
  deviceSerialNumber: string | null = null,
  studyDateTime: string | null = null,
  uploadStartedAt: string | null = null
): Promise<PublishToPubSubResponse | undefined> {
  try {
    const { pubsub, viewer } = (window as any).data;
    let studyInstanceUID = '',
      studyDate = '',
      resolvedStudyDateTime = studyDateTime,
      resolvedDeviceSerialNumber = deviceSerialNumber;

    // Only use the de-identified StudyInstanceUID if provided
    // We do not send the original StudyInstanceUID from metadata anymore
    if (newStudyInstanceUID) {
      studyInstanceUID = newStudyInstanceUID;
    }

    if (hierarchicalMetadata?.studies?.[0]) {
      const firstStudy = hierarchicalMetadata.studies[0];
      studyDate = firstStudy.StudyDate ?? '';
      // Derive studyDateTime from StudyDate + StudyTime if not provided
      if (!resolvedStudyDateTime && (firstStudy.StudyDate || firstStudy.StudyTime)) {
        const datePart = firstStudy.StudyDate ?? '';
        const timePart = firstStudy.StudyTime ?? '';
        resolvedStudyDateTime = [datePart, timePart].filter(Boolean).join(' ') || null;
      }
      if (!resolvedDeviceSerialNumber && firstStudy.DeviceSerialNumber) {
        resolvedDeviceSerialNumber = firstStudy.DeviceSerialNumber;
      }
    }

    const userEmail = localStorage.getItem('userEmail');
    const shouldIncludeViewerURL = event === 'study-ready' && studyInstanceUID;
    const viewerURL = shouldIncludeViewerURL && viewer?.viewerBaseURL
      ? `${viewer.viewerBaseURL}?StudyInstanceUIDs=${studyInstanceUID}`
      : null;

    const message = {
      actionType: event,
      studyInstanceUID: studyInstanceUID,
      Stratagen_Study_Type: studyCondition,
      studyDate: studyDate,
      error: error,
      contentType: file,
      uploadedBy: userEmail,
      ...(humanSubjectId && { humanSubjectId: humanSubjectId }),
      ...(viewerURL && { viewerURL: viewerURL }),
      ...(resolvedDeviceSerialNumber && { deviceSerialNumber: resolvedDeviceSerialNumber }),
      ...(resolvedStudyDateTime && { studyDateTime: resolvedStudyDateTime }),
      ...(uploadStartedAt && { uploadStartedAt: uploadStartedAt }),
    };

    const response = await fetch(pubsub.cloudFunctionURL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ message: message }),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    return data as PublishToPubSubResponse;
  } catch (error) {
    return undefined;
  }
}
